<template>
  <Layout>
    <PageHeader :items="items"> </PageHeader>
    <div class="container-app">
      <div class="content-title">
        <span class="title-card-app">Lista Ciudadanos</span>
        <span>
          <router-link
            size="sm"
            class="p-0 ml-2 btn-link-add"
            :to="{ name: 'home' }"
          >
            <b-icon class="icon-plus" icon="arrow90deg-left"></b-icon>
          </router-link>
        </span>
      </div>
      <div class="row mb-2 mt-2">
        <div class="col-12 d-flex justify-content-end">
          <div class="d-flex align-items-center" @click.prevent="collapsedFilter">
            <h1 class="title-filter" :class="{ 'orange': isColor, 'blue': !isColor }">
              {{ titleFilter }}
              <i class="icon-filter fas fa-filter ml-1"></i>
            </h1>
          </div>
        </div>
      </div>
      <div class="card-app" v-if="isVisble">
        <b-overlay
          :show="isBusy"
          blur="5px"
          :opacity="1"
          variant="transparent"
          spinner-variant="primary"
          spinner-type="grow"
          rounded="sm"
        >
          <div class="row">
            <div class="col-md-12 m-0 p-0">
              <div class="row">
                <div
                  class="col-md-4"
                  v-for="(variable, index) in search_variables"
                  :key="`prev-dim--base-${index}-${variable.id}`"
                >
                  <renderVariable
                    :variable="variable"
                    :isComponent="false"
                    :isPreview="false"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-12 d-flex justify-content-end mb-2">
                  <b-button
                    v-if="total_results > 0"
                    variant="outline-primary mr-2"
                    pill
                    @click.prevent="downloadReport"
                    class="ml-1"
                    :disabled="isBusyPDF"
                  >
                    <i class="fab fa fa-file-excel mr-1"></i>
                    Descargar ({{ total_results }} resultados)</b-button
                  >
                  <!-- <b-button
                  variant="outline-primary mr-2"
                    pill
                    size="md"
                    @click.prevent="reset()"
                    >Limpiar campos</b-button
                  > -->
                  <b-button
                    variant="primary"
                    pill
                    size="md"
                    @click.prevent="getReport"
                    >Buscar</b-button
                  >
                </div>
                <b-col>
                  <b-alert
                    :show="sha1 !== null"
                    variant="info"
                    class="mt-2 col-md-5 display-inline"
                    >SHA de descarga: {{ sha1 }}</b-alert
                  >
                  <b-alert
                    :show="total_results === 0"
                    variant="warning"
                    dismissible
                    class="mt-2 col-md-5 display-inline"
                    >{{ total_results }} resultados obtenidos</b-alert
                  >
                </b-col>
              </div>
            </div>
            <!-- <div>
          Forms: {{ forms_cached.results.length }}<br>
          Dimensions: {{ dimensions_cached.results.length }}<br>
          Sessions: {{ sessions_cached.length }}
      </div> -->
          </div>
        </b-overlay>
      </div>
    </div>
  </Layout>
</template>
<script>
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import { variablesMethods, reportsMethods, formMethods } from '@state/helpers'
import RenderVariable from '@views/variables/renderVariable.vue'

export default {
  page: {
    title: 'Informe: Lista Ciudadanos',
  },
  components: { Layout, PageHeader, RenderVariable },
  data() {
    return {
      items: [
        {
          text: '/',
          path: '/home',
          to: { name: 'home' },
        },
        {
          text: 'Informe: Lista Ciudadanos',
          active: true,
        },
      ],
      search_variables: [],
      variables: [],
      forms: [],
      secretaries: [],
      projects: [],
      isBusy: false,
      isBusyPDF: false,
      isVisble: true,
      isColor: true,
      report_file: null,
      sha1: null,
      total_results: null,
      titleFilter: "Filtros de búsqueda",
    }
  },

  mounted() {
    this.getVariablesData()
    // this.getForms({query: '?list=true'}).then((x) => { this.forms = x.results })
    // this.getSecretaries('?page_size=999').then((x) => { this.secretaries = x.results })
    // this.getProjects('?page_size=999').then((x) => { this.projects = x.results })
  },
  methods: {
    ...variablesMethods,
    ...formMethods,
    ...reportsMethods,

    getVariablesData() {
      this.isBusy = true
      const promise = this.getVariables(
        '?page=1&page_size=10&state=A&ordering=order&classification=1&type__in=list,boolean,date,integer,decimal&is_index=None',
        null
      )
      let _ = this
      return promise
        .then((data) => {
          this.isBusy = false
          this.search_variables = data.results.map((x) => {
            return {
              ...x,
              value: null,
              mode: 'report',
              extra_config: { required: false },
            }
          })
          return data
        })
        .catch((error) => {
          this.isBusy = false
          console.log(
            'Se presento un error en la carga de las variables.',
            error
          )
        })
    },

    getReport() {
      let payload = this.search_variables
        .filter(
          (x) =>
            (Object(x.value).hasOwnProperty('key') ? x.value.key : x.value) !==
            null
        )
        .filter((x) => {
          if (x.type != 'boolean') return true
          else return x.config.defaultValue != x.value * 1
        })
        .map((x) => {
          return {
            id: x.id,
            value: Object(x.value).hasOwnProperty('key')
              ? x.value.key
              : x.value,
          }
        })
      payload.push({ mode: 'count' })
      let _ = this
      _.isBusy = true
      _.getReportByFilterVars({ data: payload, type: { appRequest: true } })
        .then((response) => {
          const data = response.data
          _.isBusy = false
          if (data.status !== 200) {
            _.$generate_noty('error', 'Error consultando')
            _.total_results = null
            _.sha1 = null
          } else {
            _.total_results = data.count
          }
        })
        .catch((error) => {
          _.isBusy = false
          _.total_results = null
          _.sha1 = null
          console.log(
            'Se presento un error en el resultado de la consulta.',
            error
          )
        })
    },

    downloadReport() {
      let _ = this
      let payload = _.search_variables
        .filter(
          (x) =>
            (Object(x.value).hasOwnProperty('key') ? x.value.key : x.value) !==
            null
        )
        .filter((x) => {
          if (x.type != 'boolean') return true
          else return x.config.defaultValue != x.value * 1
        })
        .map((x) => {
          return {
            id: x.id,
            value: Object(x.value).hasOwnProperty('key')
              ? x.value.key
              : x.value,
          }
        })
      payload.push({ mode: 'download' })
      _.isBusy = true
      _.getReportByFilterVars({
        data: payload,
        type: { responseType: 'arraybuffer' },
      })
        .then((response) => {
          const data = response.data
          _.isBusy = false
          const url = URL.createObjectURL(
            new Blob([data], {
              type: 'application/vnd.ms-excel',
            })
          )
          const link = document.createElement('a')
          link.href = url
          let buffer = Buffer.from(response.data, 'binary')
          let decodedString = _.toHexString(buffer)

          _.digestMessage(decodedString).then((digestHex) => {
            link.setAttribute('download', `${digestHex}.xlsx`)
            _.sha1 = digestHex
            document.body.appendChild(link)
            _.$generate_toast(
              _,
              'success',
              `Descarga exitosa, verifique en sus Descargas.`
            )
            _.total_results = null
            link.click()
          })
        })
        .catch((error) => {
          _.isBusy = false
          _.$generate_toast(
            _,
            'error',
            'Se presento un error en la descarga del archivo.'
          )
          console.log('Se presento un error en la descarga del archivo.', error)
        })
    },

    toHexString(byteArray) {
      return Array.from(byteArray, function(byte) {
        return ('0' + (byte & 0xff).toString(16)).slice(-2)
      }).join('')
    },

    async digestMessage(message) {
      const msgUint8 = new TextEncoder().encode(message) // encode as (utf-8) Uint8Array
      const hashBuffer = await crypto.subtle.digest('SHA-1', msgUint8) // hash the message
      const hashArray = Array.from(new Uint8Array(hashBuffer)) // convert buffer to byte array
      const hashHex = hashArray
        .map((b) => b.toString(16).padStart(2, '0'))
        .join('') // convert bytes to hex string
      return hashHex
    },

    getAnswerValue(data) {
      if (!data) return ''
      if (typeof data.FORSESDET_VALOR_JSON === 'object') {
        if (Object(data.FORSESDET_VALOR_JSON).hasOwnProperty('value')) {
          return data.FORSESDET_VALOR_JSON.value
        } else {
          if (Array.isArray(data.FORSESDET_VALOR_JSON)) {
            return data.FORSESDET_VALOR_JSON.map((x) => x.value).join(', ')
          } else {
            return data.FORSESDET_VALOR
          }
        }
      } else {
        return data.FORSESDET_VALOR
      }
    },

    reset() {
      const me = this;
      me.search_variables.forEach(el => {
        el.value = null;
        el.extra_config = { required: false };
      });
    },

    collapsedFilter() {
      const me = this;
      if (me.isVisble) {
        me.titleFilter = "Filtros de búsqueda";
        me.isColor = false;
        me.isVisble = false;
      } else {
        me.titleFilter = "Filtros de búsqueda";
        me.isColor = true;
        me.isVisble = true;
      }
    },
  },

  watch: {
    search_variables: {
      deep: true,
      handler(newValue, oldValue) {
        this.total_results = null
        this.sha1 = null
      },
    },
  },

  computed: {},
}
</script>
<style lang="scss">
</style>
